import { PricesDTO } from '../dto/AssortmentPricesDTO';

export interface PricesProps {
  purchasePrice?: number;
  futurePurchasePrice?: number;
  costPrice?: number;
  costPriceBasePriceUnit?: string;
  markupOrPriceSuggestionPrice?: number;
  markupPrice?: number;
  priceSuggestionPrice?: number;
  roundedPrice?: number;
  salesPrice?: number;
  futureSalesPrice?: number;
  salesPriceSecondary?: number;
  salesPriceTertiary?: number;
  customerPrice?: number;
  futureCustomerPrice?: number;
  salesPricePrimaryUnit?: number;
}

export class Prices {
  purchasePrice?: number;
  futurePurchasePrice?: number;
  costPrice?: number;
  costPriceBasePriceUnit?: string;
  markupOrPriceSuggestionPrice?: number;
  markupPrice?: number;
  priceSuggestionPrice?: number;
  roundedPrice?: number;
  salesPrice?: number;
  futureSalesPrice?: number;
  salesPriceSecondary?: number;
  salesPriceTertiary?: number;
  customerPrice?: number;
  futureCustomerPrice?: number;
  salesPricePrimaryUnit?: number;

  constructor({
    purchasePrice,
    futurePurchasePrice,
    costPrice,
    costPriceBasePriceUnit,
    markupOrPriceSuggestionPrice,
    markupPrice,
    priceSuggestionPrice,
    roundedPrice,
    salesPrice,
    futureSalesPrice,
    salesPriceSecondary,
    salesPriceTertiary,
    customerPrice,
    futureCustomerPrice,
    salesPricePrimaryUnit,
  }: PricesProps) {
    this.purchasePrice = purchasePrice;
    this.futurePurchasePrice = futurePurchasePrice;
    this.costPrice = costPrice;
    this.costPriceBasePriceUnit = costPriceBasePriceUnit;
    this.markupOrPriceSuggestionPrice = markupOrPriceSuggestionPrice;
    this.markupPrice = markupPrice;
    this.priceSuggestionPrice = priceSuggestionPrice;
    this.roundedPrice = roundedPrice;
    this.salesPrice = salesPrice;
    this.futureSalesPrice = futureSalesPrice;
    this.salesPriceSecondary = salesPriceSecondary;
    this.salesPriceTertiary = salesPriceTertiary;
    this.customerPrice = customerPrice;
    this.futureCustomerPrice = futureCustomerPrice;
    this.salesPricePrimaryUnit = salesPricePrimaryUnit;
  }

  static fromDTO = (dto: PricesDTO): Prices =>
    new Prices({
      purchasePrice: dto.purchasePrice,
      futurePurchasePrice: dto.futurePurchasePrice,
      costPrice: dto.costPrice,
      costPriceBasePriceUnit: dto.costPriceBasePriceUnit,
      markupOrPriceSuggestionPrice: dto.markupOrPriceSuggestionPrice,
      markupPrice: dto.markupPrice,
      priceSuggestionPrice: dto.priceSuggestionPrice,
      roundedPrice: dto.roundedPrice,
      salesPrice: dto.salesPrice,
      futureSalesPrice: dto.futureSalesPrice,
      salesPriceSecondary: dto.salesPriceSecondary,
      salesPriceTertiary: dto.salesPriceTertiary,
      customerPrice: dto.customerPrice,
      futureCustomerPrice: dto.futureCustomerPrice,
      salesPricePrimaryUnit: dto.salesPricePrimaryUnit,
    });
}
